export default __webpack_public_path__ + "static/media/rejected.34260530.svg";